import { render } from "./main_header.vue?vue&type=template&id=00be8d31&scoped=true&ts=true"
import script from "./main_header.vue?vue&type=script&lang=ts"
export * from "./main_header.vue?vue&type=script&lang=ts"

import "./main_header.vue?vue&type=style&index=0&id=00be8d31&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00be8d31"]])

export default __exports__